import logger from '../utils/logger';
/**
 * Hook personnalisé pour gérer l'abonnement utilisateur
 */

import { useState, useEffect } from 'react';
import { authFetch } from '@/utils/api-headers';
import { API_URL } from '@/lib/config';

export interface SubscriptionData {
  subscription: {
    stripe_subscription_id: string;
    status: string;
    current_period_start: string;
    current_period_end: string;
    cancel_at?: string;
  } | null;
  profile: {
    subscription_tier: string;
    subscription_tokens_monthly: number;
    subscription_tokens_used: number;
    tokens_rollover: number;
  } | null;
}

export function useSubscription() {
  const [data, setData] = useState<SubscriptionData | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const load = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await authFetch(`${API_URL}/api/billing/subscription-status`);

      if (response.ok) {
        const result = await response.json();
        setData(result);
      } else {
        throw new Error('Failed to load subscription');
      }
    } catch (err: any) {
      logger.error('Error loading subscription:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const cancel = async () => {
    try {
      const response = await authFetch(`${API_URL}/api/billing/cancel-subscription`, {
        method: 'POST',
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to cancel subscription');
      }

      await load(); // Recharger
      return true;
    } catch (err: any) {
      logger.error('Error cancelling subscription:', err);
      throw err;
    }
  };

  useEffect(() => {
    load();
  }, []);

  return {
    data,
    loading,
    error,
    reload: load,
    cancel,
  };
}

